<template>
    <div v-if="accountData">
        <div class="bg-white mb-3">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <h1 class="h4 mb-0">{{ accountData.code }} - {{accountData.dentist.first_name}} {{accountData.dentist.surname}} at {{accountData.practice.company_name}}</h1>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <router-link :to="{ name: 'Account', params: { account_id: accountData.id }}" class="nav-link">Transactions</router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'Statements', params: { account_id: accountData.id }}" class="nav-link active">Statements</router-link>
            </li>
            <li v-if="accountExports" class="nav-item">
                <router-link :to="{ name: 'AccountExports', params: { account_id: accountData.id }}" class="nav-link">Exports</router-link>
            </li>
            <li class="nav-item">
                <router-link :to="{ name: 'CreditRequests', params: { account_id: accountData.id }}" class="nav-link">Credit Requests</router-link>
            </li>
        </ul>
        <div class="bg-white pt-4">
            <table v-if="statementsData" class="statements-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th class="column-shrink"></th>
                    </tr>
                </thead>
                <tbody v-for="(statement, statementIndex) of statementsData.data" v-bind:key="statementIndex" class="mb-1">
                    <tr>
                        <td>
                            {{this.$filters.formatDateMonthYear(statement.date)}}
                        </td>
                        <td class="column-number">
                             <a class="btn btn-secondary" :href="statement.url" target="_blank">View</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="statementsData && !statementsData.data.length">
                No Statements
            </div>
            <Pagination
                v-if="statementsData && statementsData.data.length"
                v-bind:currentPage="currentPage"
                v-bind:lastPage="lastPage"
                viewComponent="Statements"
            />
        </div>      
    </div>
</template>

<style scoped lang="scss">
    .statements-table
    {
        border-collapse: collapse;
        width: 100%;
        line-height: 1em;

        &.product-table-collapsed
        {
            width: auto;
        }
        
        td
        {
            border-top: 1px solid #EEEEEE;
        }

        td,
        th
        {
            vertical-align: middle;
            padding: 10px 0.75em;

            &:first-child
            {
                padding-left: 0px;
            }

            &:last-child
            {
                padding-right: 0px;
            }
        }

        .column-shrink
        {
            width: 0px;
            white-space: nowrap;
        }

        .column-number
        {
            width: 0px;
            white-space: nowrap;
        }

        td.column-number
        {
            text-align: right;
        }
    }
</style>

<script>
    import api from "@/services/api";
    import Pagination from '@/components/Pagination.vue';

    export default {
        props: {
            id: {
                required: true
            }
        },
        components: {            
            Pagination,
        },
        data() {
            return {
                types: [],
                accountData: null,
                statementsData: null,
            };
        },
        mounted () {
            this.fetchAccount();
        },
        computed: {
            currentPage () {
                var pageParam = this.$route.query.page;
                return typeof pageParam === 'undefined' ? 1 : parseInt(pageParam);
            },
            lastPage () {
                if(this.transactionsData !== null)
                {
                    return parseInt(this.statementsData.meta.last_page);
                }

                return null;
            },
        },
        watch: {
            currentPage() {
                this.fetchStatements();
            },
            '$store.state.currentPracticeId': function() {
                this.fetchStatements();
            }
        },
        methods: {
            fetchAccount: function() {                
                api
                .get('/api/v1/accounts/' + this.id)
                .then((response) => {
                    this.accountData = response.data.data;

                    this.fetchStatements();
                })
                .catch(() => {
                    console.log('Catch account error');
                });
            },
            fetchStatements: function() {  
                var params = {
                    page: this.currentPage,
                };

                api
                .get('/api/v1/accounts/' + this.id + '/statements', {
                    params: params,
                })
                .then((response) => {
                    this.statementsData = response.data;
                })
                .catch(() => {
                    console.log('Catch statements error');
                });
            },
        },
    }

</script>
